'use client';
import MuiDivider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import idsTokensDefault from '../../utils/tokens/idsTokens';
import withRef from '../../utils/withRef';

export const styles = ({ idsTokens = idsTokensDefault }) => ({
  light: {
    '&.MuiDivider-root': {
      borderColor: idsTokens.divider.default.color.light,
    },
  },
  dark: {
    '&.MuiDivider-root': {
      borderColor: idsTokens.divider.default.color.dark,
    },
  },
  semiopaque: {
    '&.MuiDivider-root': {
      borderColor: idsTokens.divider.default.color.semiOpaque,
    },
  },
});

const useStyles = makeStyles()(styles);

export const Divider = ({ className, type, forwardedRef: ref, ...rest }) => {
  const { classes, cx } = useStyles();
  return <MuiDivider className={cx(classes[type], className)} {...rest} ref={ref} />;
};

Divider.propTypes = {
  /**
   * Style options for `Divider`.
   * Default is no value and a medium coloring.
   */
  type: PropTypes.oneOf(['default', 'dark', 'light', 'semiopaque']),
};

export default withRef()(Divider);
